module.exports = __webpack_public_path__ + "assets/f13077d2410c5c535581c2d4a22b2594.svg";